// @import Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { GoogleLogin } from '@react-oauth/google';

// @import Reducers
import { google as googleAuth } from '../../redux/slices/auth';

// @import Utilities
import { snack } from '../../utils/snackbar';

export const WriterlyGoogleAuth = ({ containerProps, buttonProps, token }) => {
  const dispatch = useDispatch();

  return (
    <div
      className="mt-5 mx-auto"
      {...containerProps}
      id="google-auth-container"
    >
      <GoogleLogin
        onSuccess={(credentialResponse) => {
          dispatch(
            googleAuth({ credential: credentialResponse.credential, token })
          );
        }}
        onError={(error) => {
          snack('error', error);
        }}
        shape="circle"
        size="large"
        width={270}
        auto_select={false}
        {...buttonProps}
      />
    </div>
  );
};

WriterlyGoogleAuth.propTypes = {
  containerProps: PropTypes.any,
  buttonProps: PropTypes.any,
  token: PropTypes.any,
};
